import handlebars from "handlebars"
import { html_beautify } from "js-beautify"

export default new class TemplateEngine {
  constructor() {
    this.hbs = handlebars.create()
    this.registerDefaultHelpers()
    this.registerDefaultPartials()
  }

  registerDefaultHelpers() {
    this.hbs.registerHelper('concat', (...strings) => strings.slice(0, -1).join(''))
    this.hbs.registerHelper('tag', function tag(tag, { hash: { $hash = {}, ...hash } = {}, fn }) {
      const props = Object.entries({ ...$hash, ...hash })
        .map(([attr, value]) => ([false, undefined, null, ''].includes(value) ? [] : value === true ? [attr] : [attr, `"${value}"`])
          .join('='))
        .filter(i => i)
        .join(' ')

      if (fn) {
        try {
          const children = fn(this)
          return `<${tag} ${props}>
          ${children}
          </${tag}>`
        } catch (error) {
          return 'error on render tag helper'
        }
      }
      return `<${tag} ${props} />`
    })
    this.hbs.registerHelper('eq', (left, right) => left === right)
    this.hbs.registerHelper('or', (...args) => args.slice(0, -1).some(Boolean))
    this.hbs.registerHelper('raw', (v, options) => v);
    ['dbas', 'dbas_group', 'dba_input', 'dba_label', 'consent_checkbox'].forEach(helperName => {
      this.hbs.registerHelper(helperName, options => {
        if (typeof options === 'object' && typeof options.fn === 'function') {
          return `{{#${helperName}}}${options.fn()}{{/${helperName}}}`
        }
        const attrs = Object.entries(options.hash || {})
          .map(([key, value]) => `${key}="${value}"`)
          .join(' ')
        return `{{{${helperName} ${attrs}}}}`
      })
    })
  }

  registerDefaultPartials() {
    this.hbs.registerPartial('$children', `{{#if @partial-block}}{{> @partial-block }}{{/if}}`)
  }

  updateBlockTemplate({ template, key }) {
    this.hbs.unregisterPartial(key);
    this.hbs.registerPartial(key, template)
  }

  async compileBlocks(block, blocks, currentScope) {
    if (!blocks || !blocks.length) {
      return `{{>${block}}}`
    }

    const children = []
    for (const { block, scope, blocks: blocks_children } of blocks) {
      const template = await this.compileBlocks(block, blocks_children, scope)
      const fn = this.hbs.compile(template)
      try {
        children.push(fn({}, {
          data: {
            ...currentScope,
            ...scope,
            $external: {
              ...currentScope.$external || {},
              ...scope.$external || {},
            },
          },
        }))
      } catch (error) {
        children.push('error on render tamplate block children')
      }
    }

    return `{{#>${block}}}${children.join('\n')}{{/${block}}}`
  }

  async preCompileTemplate(blocks) {
    const { hbs } = this
    const compiler = new class extends Array {
      compile(data) {
        const html = this.map(({ template, scope }) => {
          const fn = hbs.compile(template)
          try {
            return fn(data, { data: scope })
          } catch (error) {
            return 'error on render tamplate block'
          }
        })
          .join('\n')

        return html_beautify(html, {
          indent_size: 2,
        })
      }
    }

    for (const { block, blocks: blocks_children, scope } of blocks) {
      const template = await this.compileBlocks(block, blocks_children, scope)
      compiler.push({ template, scope })
    }

    return compiler
  }
}
